import '../IncrementalityPlaybook.scss';
import { Img } from '@Components/Img';
import { CommonShoppingSections } from './Shopping';
import { INC_CDN, IncPlaybookSectionBox } from '../IncrementalityPlaybookShared';

const PAGE_TITLE = 'Google Search';

export const GoogleSearch = () => (
  <div className='inc-playbook-page'>
    <IncPlaybookSectionBox
      content={
        <div className='basic-section'>
          <div className='basic-text'>
            Search ads is the concept of getting your website or ad campaigns listed at the top of
            the search results for any questions, keywords or phrases.
          </div>
          <br />
          <div className='basic-text'>
            Of note, methods outlined below are similar across google platforms for Search,
            Shopping, Display ( DV360) & Demand Gen (fka Discovery).
          </div>
          <br />
          <Img src={`${INC_CDN}/Google_SponsoredSearch.png`} />
        </div>
      }
      pageTitle={PAGE_TITLE}
      title='Overview'
    />
    <CommonShoppingSections
      pageTitle={PAGE_TITLE}
      sections={[
        'Incrementality Testing Approaches',
        'Media Options & Considerations',
        'Sample Output',
        'Google Power Calculation',
        'Signal Enrichment'
      ]}
    />
  </div>
);
